import { featuresData } from '@/mocks/homeData';

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-10 text-center">
          {featuresData.title}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.items.map((item, i) => (
            <div
              key={item.title}
              className="group p-6 md:p-7 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300 transition-all duration-300 text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 flex items-center justify-center rounded-xl bg-primary-100 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}